export default "__VITE_ASSET__CT6mcOCD__"